module.exports = __webpack_public_path__ + "img/Bus.b427fcd3.svg";